import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetBoosterSubHeaderButton } from "./BetBoosterSubHeaderButton";

export const BetBoostersSubHeader = observer(function BetBoostersSubHeader() {
	const { t } = useTranslation();

	const bettingTipsList: { abrv: "betting-tips"; name: string } = {
		abrv: "betting-tips",
		name: t("QUICK_PLAY.BETTING_TIPS.TITLE"),
	};

	const betBuilderList: { abrv: "bet-builder"; name: string } = {
		abrv: "bet-builder",
		name: "Bet Builder",
	};

	return (
		<div className="event__tabs event__tabs--borderless u-padd--x--reset u-padd--top--reset">
			<div className="tabs tabs--scroll tabs--boxed scrollbar--custom">
				<BetBoosterSubHeaderButton subHeaderType={betBuilderList} />
				<BetBoosterSubHeaderButton subHeaderType={bettingTipsList} />
			</div>
		</div>
	);
});
